import {
  Stack,
  AvatarGroup,
  Box,
  Tooltip,
  Avatar,
  List,
  ListItem,
  ListItemText,
  Popover,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { isEmpty } from 'lodash';
import { useState } from 'react';

type AttendeeAvatarProps = {
  attendees: string[];
};

const AttendeeAvatarSurplus = ({ list, skip, ...props }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <ThemeProvider
      theme={(theme) =>
        createTheme({
          ...theme,
          palette: {
            mode: 'light',
          },
        })
      }
    >
      {list?.length > skip && (
        <Avatar
          {...props}
          onClick={handleClick}
          sx={{
            ...props.sx,
            cursor: 'pointer',
            bgcolor: '#CAF0F8',
            color: 'common.black',
            height: avatarSize,
            width: avatarSize,
            fontSize: avatarSize / 2,
          }}
        >
          +{list?.length - skip}
        </Avatar>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List>
          {list
            ?.filter((e, i) => i >= skip)
            .map((listItem, i) => (
              <ListItem key={i}>
                <ListItemText primary={listItem} />
              </ListItem>
            ))}
        </List>
      </Popover>
    </ThemeProvider>
  );
};

const avatarSize = 30;

const TeamAvatarGroupEvent = ({ attendees }: AttendeeAvatarProps) => {
  function stringToColor(string: string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  }

  function stringAvatar(name: string, index?: number) {
    return {
      sx: {
        bgcolor:
          index !== undefined
            ? ['#F6EBD0', '#FDC9D0', '#BBF2EF', '#CAF0F8'][index]
            : stringToColor(name),
        color: 'common.black',
      },
    };
  }

  const maxIcon = 4;

  function getName(name: string) {
    return name
      .split(' ')
      .map((nameSubStr) => nameSubStr[0].toUpperCase())
      .join('');
  }

  return (
    <Box>
      {attendees && !isEmpty(attendees) && (
        <Stack direction="row" spacing={2}>
          <AvatarGroup max={maxIcon} sx={{ maxWidth: '10.5rem', justifyContent: 'flex-end' }}>
            {attendees &&
              attendees.map((attendee, index) => {
                const surplus = index === 3 && attendees.length > 4;
                const initials = getName(attendee).toUpperCase();
                const props = { ...stringAvatar(initials, index) };
                props.sx['width'] = avatarSize;
                props.sx['height'] = avatarSize;
                props.sx['fontSize'] = avatarSize / 2;
                return (
                  index <= 3 &&
                  (surplus ? (
                    <AttendeeAvatarSurplus
                      openTeamDrawer={undefined}
                      list={attendees}
                      {...props}
                      skip={3}
                    />
                  ) : (
                    <Tooltip key={index} title={attendee}>
                      <Avatar
                        {...props}
                        onClick={(e: any) => {
                          if (index + 1 < maxIcon) {
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        }}
                      >
                        {initials}
                      </Avatar>
                    </Tooltip>
                  ))
                );
              })}
          </AvatarGroup>
        </Stack>
      )}
    </Box>
  );
};

export default TeamAvatarGroupEvent;
